import { Api, IConfig } from '@estee/elc-service';

const { name, version } = __serviceInfo__;
export interface IConfigStoreData {
    data: Record<string, unknown>;
}

export class ConfigMangerApiSdk extends Api {
    private apiUrl: string;

    constructor(configStore: IConfig) {
        super(configStore, name, version);
        this.apiUrl = 'stardust-buid-configurations-v1';
    }

    public async getConfigByBusinessUnitId(businessUnitId: string) {
        const url = `/${this.apiUrl}/configurations/${businessUnitId}`;
        const response: IConfigStoreData = await this.get(url);

        return response.data;
    }
}
